import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'

export const FilterTabs = ({ activeTab, onTabChange }) => {
	const { t } = useTranslation('common')

	return (
		<div className='vehicle-parts-filter-tabs'>
			<button className={`vehicle-parts-filter-tab ${activeTab === 'filters' ? 'active' :  ''}`} onClick={() => onTabChange('filters')}>
				<img src={'/icons/auto.svg'} alt='search' width={25} height={20} />
				<p>{t('Pretraga po vozilu')}</p>
			</button>
			<button className={`vehicle-parts-filter-tab ${activeTab === 'text' ? 'active' :  ''}`} onClick={() => onTabChange('text')}>
				<img src={'/icons/barkod.svg'} alt='search' width={40} height={18} />
				<p>{t('Pretraga po kataloškom broju')}</p>
			</button>
		</div>
	)
}

FilterTabs.propTypes = {
	activeTab: PropTypes.string.isRequired,
	onTabChange: PropTypes.func.isRequired,
}
